import { render, staticRenderFns } from "./ShowWokerInfo.vue?vue&type=template&id=0b0a96bd&"
import script from "./ShowWokerInfo.vue?vue&type=script&lang=js&"
export * from "./ShowWokerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowWokerInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports